import axios from "./axiosInstance";
import config from "./config";
import { getAuthToken } from "./apiHelpers";

const BASE_URL = config.BASE_URL;

export type Tier = "starter" | "growth" | "pro" | "enterprise";
export type SubscriptionStatus = "active" | "trial" | "past_due" | "cancelled";
export type GatingMode = "hard" | "soft" | "frontend_only" | "marketing_only";
export type DenialReason = "tier" | "addon" | "no_subscription";

export interface ModuleEntitlement {
  module_key: string;
  name: string;
  gating: GatingMode;
  is_marquee: boolean;
  required_tier: Tier | null;
  required_addon: string | null;
  price: number;
  granted: boolean;
  reason?: DenialReason;
}

export interface TenantEntitlementsResponse {
  success: boolean;
  tier: Tier | null;
  status: SubscriptionStatus | null;
  addons: string[];
  modules: ModuleEntitlement[];
}

/**
 * Fetch the boot-time entitlement payload for the current tenant.
 * Powers the useModuleEntitled hook + <ModuleGate> component.
 *
 * Backend implementation: backend/src/controllers/entitlementsController.js
 * Returns 200 + { tier, status, addons, modules } on success.
 */
export const getTenantEntitlements =
  async (): Promise<TenantEntitlementsResponse> => {
    const token = getAuthToken();
    const res = await axios.get(`${BASE_URL}/tenant/entitlements`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  };
